import { Config } from "./config.service";
import { toast } from "react-toastify";
import { AuthService } from "core/service/auth.service";
import { UtilService } from "core/utils/utils";
import i18next from "translation/i18n";

export class User {
  url = Config.getBaseUrl();
  auth = Config.getClientInfo();
  accessToken = AuthService.getToken("accessToken");

  getSignupConfig() {
    const requestHeaders = {
      method: "GET",
    };

    return fetch(`${this.url}/users/signup`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        return {
          data: {
            enableNewSignup: response.enable_new_signup,
            enablePhoneNumber: response.enable_phone_number,
          },
        };
      })
      .catch((err) => {
        console.error("Error fetching signup config:", err);
      });
  }
  signup(user) {
    const requestBody = UtilService.convertToFormdata({
      ...user,
      //GST-478 - Added gdpr email consent for the HTML update
      send_email: Boolean(user.send_email),
      ...this.auth,
    });

    const requestHeaders = {
      method: "POST",
      body: requestBody,
    };

    return fetch(`${this.url}/users/signup`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.status === 204 ? true : response.json();
      })
      .then((response) => {
        if (typeof response === "boolean") return true;

        AuthService.setUser(response.payload);
        AuthService.setSessionid(response.payload.sessionid);

        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          return error;
        });
      });
  }

  async resendActivationCode(user) {
    const requestBody = UtilService.convertToFormdata({
      ...user,
    });
    const requestHeaders = {
      method: "POST",
      body: requestBody,
    };
    try {
      const response = await fetch(
        `${this.url}/users/activation/resend/`,
        requestHeaders
      );
      if (!response.ok) {
        throw response;
      }
      const data = await response.json();
      toast.success(
        data.success_message
          ? UtilService.convertErrorMessage(data.success_message)
          : i18next.t("activationCode.response.success_message")
      );
      return data;
    } catch (err) {
      err.json().then((error) => {
        toast.error(
          error.error_message
            ? UtilService.convertErrorMessage(error.error_message)
            : i18next.t("activationCode.response.error_message")
        );
        return error;
      });
    }
  }

  signin(user) {
    const requestBody = UtilService.convertToFormdata({
      ...user,
      ...this.auth,
    });
    const requestHeaders = {
      method: "POST",
      body: requestBody,
    };
    return fetch(`${this.url}/users/signin`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        AuthService.setUser(response.payload);
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          return error;
        });
      });
  }

  forgotpassword(user) {
    const requestBody = UtilService.convertToFormdata(user);
    const requestHeaders = {
      method: "POST",
      body: requestBody,
    };
    return fetch(`${this.url}/users/password-reset`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        toast.success(
          response.success_message
            ? UtilService.convertErrorMessage(response.success_message)
            : i18next.t("forgotpassword.response.success_message")
        );
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          toast.error(
            error.error_message
              ? UtilService.convertErrorMessage(error.error_message)
              : i18next.t("forgotpassword.response.error_message")
          );
          return error;
        });
      });
  }

  getprofile() {
    const requestHeaders = {
      method: "GET",
      headers: { Authorization: `Bearer ${this.accessToken}` },
    };
    return fetch(`${this.url}/users/edit-profile`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          toast.error("Failed to load data");
          return error;
        });
      });
  }

  activateAccount(token) {
    const requestHeaders = {
      method: "GET",
    };
    return fetch(`${this.url}/users/account/${token}/activate`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        toast.success(
          response.success_message
            ? UtilService.convertErrorMessage(response.success_message)
            : i18next.t("activationCode.response.success_message")
        );
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          toast.error(
            error.error_message
              ? UtilService.convertErrorMessage(error.error_message)
              : i18next.t("activationCode.response.error_message")
          );
          return error;
        });
      });
  }

  updateprofile(user) {
    const requestBody = UtilService.convertToFormdata(user);
    const requestHeaders = {
      method: "POST",
      headers: { Authorization: `Bearer ${this.accessToken}` },
      body: requestBody,
    };
    return fetch(`${this.url}/users/edit-profile`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        toast.success(
          response.success_message
            ? UtilService.convertErrorMessage(response.success_message)
            : i18next.t("profile.response.success_message")
        );
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          toast.error(
            error.error_message
              ? UtilService.convertErrorMessage(error.error_message)
              : i18next.t("profile.response.error_message")
          );
          return error;
        });
      });
  }

  getpreferences(type) {
    const requestHeaders = {
      method: "GET",
      headers: { Authorization: `Bearer ${this.accessToken}` },
    };
    return fetch(
      `${this.url}/users/get-preferences?type=${type}`,
      requestHeaders
    )
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          toast.error("Failed to load data");
          return error;
        });
      });
  }

  getagentdetails() {
    const requestHeaders = {
      method: "GET",
      headers: { Authorization: `Bearer ${this.accessToken}` },
    };
    return fetch(`${this.url}/users/agent-user`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          toast.error("Failed to load data");
          return error;
        });
      });
  }

  updateagentdetails(user) {
    const requestBody = UtilService.convertToFormdata(user);
    const requestHeaders = {
      method: "POST",
      headers: { Authorization: `Bearer ${this.accessToken}` },
      body: requestBody,
    };
    return fetch(`${this.url}/users/agent-user`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        toast.success(
          response.success_message
            ? UtilService.convertErrorMessage(response.success_message)
            : i18next.t("preferences.response.success_message")
        );
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          /* handle error message from Backend*/
          toast.error(i18next.t("preferences.response.error_message"));
          return error;
        });
      });
  }

  deleteagentdetails() {
    const requestHeaders = {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this.accessToken}` },
    };
    return fetch(`${this.url}/users/agent-user`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        toast.success(
          response.success_message
            ? UtilService.convertErrorMessage(response.success_message)
            : "Agent Preferences updated successfully"
        );
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          /* handle error message from Backend*/
          toast.error("Agent Preferences update failed");
          return error;
        });
      });
  }

  cancelaccount() {
    const requestHeaders = {
      method: "POST",
      headers: { Authorization: `Bearer ${this.accessToken}` },
    };
    return fetch(`${this.url}/users/deactivate`, requestHeaders)
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((response) => {
        toast.success(
          response.success_message && response.success_message !== ""
            ? response.success_message
            : "Your account has been cancelled successfully"
        );
        return response;
      })
      .catch((err) => {
        err.json().then((error) => {
          /* handle error message from Backend*/
          toast.error("Cancel your account failed");
          return error;
        });
      });
  }
}

export const UserService = new User();
